module.exports = __webpack_public_path__ + "static/media/suryanamskar.c41e1a2f.jpg";